<p-tabView (onChange)="onTabChange($event)">
   <p-tabPanel header="PNG">
     <div class="container">
       <p-floatLabel>
         <input pInputText id="filename" [(ngModel)]="fileName" />
         <label for="filename">File Name</label>
       </p-floatLabel>
     </div>
    </p-tabPanel>
    <p-tabPanel header="ZIP">
      <div class="container">
        <p-floatLabel>
          <input pInputText id="filename" [(ngModel)]="fileName" />
          <label for="filename">File Name</label>
        </p-floatLabel>
      </div>
    </p-tabPanel>
    <!--<p-tabPanel header="PSD" [disabled]="false">-->
    <!-- <div class="container">-->
    <!--   <p-floatLabel>-->
    <!--     <input pInputText id="filename" [(ngModel)]="fileName" />-->
    <!--     <label for="filename">File Name</label>-->
    <!--   </p-floatLabel>-->
    <!--   <div class="checkbox">-->
    <!--     <p-checkbox-->
    <!--       value="New York"-->
    <!--       inputId="filterContext"-->
    <!--       [binary]="true"-->
    <!--       [(ngModel)]="filterContext"-->
    <!--       />-->
    <!--       <div class="warning">-->
    <!--         <label for="filterContext">Include Filter Context</label>-->
    <!--         <p-button [rounded]="true" [text]="true" icon="pi pi-exclamation-circle" severity="warning"></p-button>-->
    <!--       </div>-->
    <!--   </div>-->
    <!-- </div>-->
    <!--</p-tabPanel>-->
</p-tabView>
<div class="bottom">
  <p-button label="Cancel" severity="secondary" (onClick)="closeDialog()"></p-button>
  <p-button label="Export" [loading]="saving" severity="primary" (onClick)="save()"></p-button>
</div>
